import React from 'react';
import './Pages.css';

const TutorDashboard = () => {
  return (
    <div className="page">
      <section className="page-header">
        <div className="container">
          <div className="page-title">Tutor Dashboard</div>
          <div className="page-subtitle">Verwalten Sie Ihre Kurse und Teilnehmer</div>
        </div>
      </section>
      
      <section className="content-section">
        <div className="container">
          <div style={{ padding: '2rem', background: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
            <h3>Tutor Dashboard</h3>
            <p>Tutor management interface will be implemented here</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TutorDashboard;
